const questions = [
    "On a scale of 1-5, how would you rate this course?",
    "Based on your expectations, was this course easy or tough?",
    "What did you like about this course?",
    "Are there things we could do better?",
    "Do you find the course useful?",
    "Would you recommend this course to anyone else?",
    "Any other thoughts?"
]

export default questions;